import { NgModule } from '@angular/core';
import { ArticlePageCommonComponent } from './lib/components/article-page-common/article-page-common.component';
import { BooksComponent } from './lib/components/books/books.component';
import { HighlightPipe } from './lib/pipes/highlight/highlight.pipe';
import { ArticleResultComponent } from './lib/components/article-result/article-result.component';
import { SearchComponent } from './lib/components/search/search.component';
import { SafeHtmlPipe } from './lib/pipes/safe-html/safe-html.pipe';
import { InterprationPageComponent } from './pages/interpration-page/interpration-page.component';
import { BookComponent } from './lib/components/book/book.component';
import { HeaderComponent } from './lib/components/header/header.component';
import { InterpretationComponent } from './lib/components/interpretation/interpretation.component';
import { SpinnerComponent } from './lib/components/spinner/spinner.component';
import { SearchRedirectComponent } from './lib/components/search-redirect/search-redirect.component';
import { FilterLangComponent } from './lib/components/filter-lang/filter-lang.component';
import { ArticleComponent } from './lib/components/article/article.component';
import { IndexComponent } from './lib/components/index/index.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { SearchPageComponent } from './pages/search-page/search-page.component';
import { FlyingPageComponent } from './pages/flying-page/flying-page.component';
import { TabsPageComponent } from './pages/tabs-page/tabs-page.component';
import { InterpretationDetailComponent } from './lib/components/interpretation-detail/interpretation-detail.component';
import { InterpretationRowComponent } from './lib/components/interpretation-row/interpretation-row.component';
import { ArticlePageComponent } from './pages/article-page/article-page.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
import { ComponentsModule } from '../library/components/components/components.module';
import { FormsModule } from '@angular/forms';
import { ContextService } from './lib/services/context/context.service';
import { CommonTranslateModule } from '../common-page-components/transloco-module/common-translate-module.module';


@NgModule({
  declarations: [
    BooksComponent,
    ArticlePageCommonComponent,
    HighlightPipe,
    ArticleResultComponent,
    SearchComponent,
    SafeHtmlPipe,

    InterprationPageComponent,
    BooksComponent,
    BookComponent,
    HeaderComponent,
    InterpretationComponent,
    SpinnerComponent,
    SearchRedirectComponent,
    FilterLangComponent,
    ArticleComponent,
    IndexComponent,
    ArticlePageCommonComponent,
    HomePageComponent,
    SearchPageComponent,
    FlyingPageComponent,
    TabsPageComponent,
    InterpretationDetailComponent,
    InterpretationRowComponent,
    ArticlePageComponent
  ],
  providers:[
    ContextService,
  ],
  imports:[
    CommonModule,
    RouterModule,
    CommonTranslateModule,
    CommonPageComponentsModule,
    ComponentsModule,
    FormsModule
  ],
  exports: [
    BooksComponent,
    ArticlePageCommonComponent,
    CommonTranslateModule,
    HighlightPipe,
    ArticleResultComponent,
    SearchComponent,
    SafeHtmlPipe,
    InterprationPageComponent,
    BooksComponent,
    BookComponent,
    HeaderComponent,
    InterpretationComponent,
    SpinnerComponent,
    SearchRedirectComponent,
    ArticlePageComponent,
    FilterLangComponent,
    ArticleComponent,
    IndexComponent,
    ArticlePageCommonComponent,
    HomePageComponent,
    SearchPageComponent,
    FlyingPageComponent,
    TabsPageComponent,
    InterpretationDetailComponent,
    InterpretationRowComponent,
  ]
})
export class CommonRulebookComponentsModule { }
